import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NewAlertComponent } from './new-alert.component';

@NgModule({
  declarations: [NewAlertComponent],
  imports: [CommonModule],
  exports: [NewAlertComponent]
})
export class NewAlertModule { }
